import { useCallback, useEffect, useMemo, useState } from 'react';
import { storageBus } from 'services/storageBus';

function useBrowserStorage(key, initialValue, namespace = null, storage = 'localStorage', subscribe = false) {
  const read = useCallback(
    () => storageBus.read({ key, namespace, storage, initialValue }),
    [key, namespace, storage, initialValue],
  );

  const [storedValue, setStoredValue] = useState(read);

  const write = useCallback(
    (nextValue) => storageBus.write({ key, namespace, storage, value: nextValue }),
    [key, namespace, storage],
  );

  const setValue = useCallback(
    (value) => {
      setStoredValue((current) => {
        const nextValue = value instanceof Function ? value(current) : value;
        write(nextValue);
        return nextValue;
      });
    },
    [write],
  );

  useEffect(() => {
    if (!subscribe) {
      return;
    }
    const unsubscribe = storageBus.subscribe({ key, namespace, storage }, () => {
      // Defer to avoid setState-in-render edge cases
      setTimeout(() => setStoredValue(read()), 0);
    });
    return unsubscribe;
  }, [key, namespace, storage, read, subscribe]);

  return useMemo(() => [storedValue, setValue], [storedValue, setValue]);
}

export default useBrowserStorage;
